import { render, staticRenderFns } from "./TransitionCollapse.vue?vue&type=template&id=265cc491"
import script from "./TransitionCollapse.vue?vue&type=script&lang=js"
export * from "./TransitionCollapse.vue?vue&type=script&lang=js"
import style0 from "./TransitionCollapse.vue?vue&type=style&index=0&id=265cc491&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports